/**
 * Cuantas columnas tiene una grilla `auto-fill` en este momento.
 *
 * La grilla decide sus columnas por el ancho (de 2 en el telefono a 6 en una
 * pantalla ancha), y quien la corta en dos necesita cortar en una fila entera
 * para no dejar un hueco al final de la primera parte. Se lee del estilo ya
 * calculado, no se repiten aca los anchos minimos del CSS.
 *
 * Se mide antes de pintar (`useLayoutEffect`): el corte no salta a la vista.
 */
import { useLayoutEffect, useRef, useState, type RefObject } from 'react';

/** Mientras no se mide: lo comun en un escritorio. */
const COLUMNAS_SUPUESTAS = 4;

export function useColumnasGrilla<T extends HTMLElement>(): [RefObject<T | null>, number] {
  const caja = useRef<T>(null);
  const [columnas, setColumnas] = useState(COLUMNAS_SUPUESTAS);

  useLayoutEffect(() => {
    const grilla = caja.current?.querySelector('.grilla-prod');
    if (grilla === null || grilla === undefined) return;

    const medir = (): void => {
      const pistas = getComputedStyle(grilla).gridTemplateColumns.split(' ').filter(Boolean);
      setColumnas(Math.max(1, pistas.length));
    };

    medir();
    const observador = new ResizeObserver(medir);
    observador.observe(grilla);
    return () => {
      observador.disconnect();
    };
  }, []);

  return [caja, columnas];
}
